import React from "react";
import { safeJsonLd } from "@/utils/jsonLd";
import IMAGES from "../../data/assetData";
import Image from "next/image";
import FaqAccordion from "./FaqAccordion";

const FaqSection = ({ showHeading, seoAllData, includeSchema = true }) => {
  let faqData = [];
  try {
    const faq = JSON.parse(seoAllData?.faq || "[]");
    faqData = Array.isArray(faq) ? faq : [];
  } catch {
    faqData = [];
  }

  if (!seoAllData || faqData.length === 0) {
    return null;
  }

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqData.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: { "@type": "Answer", text: item.answer },
    })),
    speakable: {
      "@type": "SpeakableSpecification",
      cssSelector: ["#faq-heading", ".faq-question", ".faq-answer"],
    },
  };

  return (
    <section
      className="w-[92%] mx-auto my-16 max-lg:w-auto max-lg:mx-[5%] max-lg:my-12"
      aria-labelledby={showHeading ? "faq-heading" : undefined}
    >
      {includeSchema && (
        <script
          type="application/ld+json"
          data-faq-schema={seoAllData?.id || 'default'}
          dangerouslySetInnerHTML={{ __html: safeJsonLd(faqSchema) }}
          suppressHydrationWarning
        />
      )}

      {showHeading && (
        <div className="text-center flex flex-col items-center">
          <div className="flex items-center">
            <h2 id="faq-heading" className="font-poppins text-3xl lg:text-[38px] max-lg:text-2xl font-semibold text-textPrimary">
              Frequently Asked{" "}
              <span className="text-teal inline-flex">
                Questions!{" "}
                <Image
                  src={IMAGES.question_icon}
                  alt="Question Icon"
                  width={34}
                  height={34}
                  className="align-middle mb-[10px] ml-[-4px]"
                />
              </span>
            </h2>
          </div>
        </div>
      )}

      <FaqAccordion faqData={faqData} />
    </section>
  );
};

export default FaqSection;
